module.exports = __webpack_public_path__ + "img/star.21cf8e5e.png";